import { useQuery } from '@tanstack/react-query';
import { getCommissionsActiveSteps } from 'config/requests/comissions';

export const useCommissionsActiveSteps = (id: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: ['commissions/commissionsActiveSteps', id],
    queryFn: () => getCommissionsActiveSteps(id!),
    enabled: Boolean(id),
  });

  return { data, isLoading };
};
